const Validator = {
  BETWEEN: (minValue, maxValue) => ({ between: [minValue, maxValue] }),
  REQUIRED: { required: true },
  MIN_VALUE: (minValue) => ({ min_value: minValue }),
  GREATER_THAN: (minExcl) => ({ greaterThan: minExcl }),
  MAX_VALUE: (maxValue) => ({ max_value: maxValue }),
  LESS_THAN: (maxExcl) => ({ lessThan: maxExcl }),
  REGEX: (expression) => ({ regex: expression }),
  LENGTH: (min) => ({ length: { min } }),
  MAX: (maxValue) => ({ max: maxValue }),
  NOT_IN: (list) => ({ notIn: list }),
  CUSTOM: (customValue, args = true) => ({ [customValue]: args }),
  INTEGER: { integer: true },
  CONFIRMED: (target) => ({ confirmed: target }),
};

export default Validator;
